module.exports = __webpack_public_path__ + "img/audit.98d96088.png";